import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  TextField
} from '@material-ui/core'

import ButtonGZ from '../../components/Button'
import useStyles from './styles'

import Context from '../../context'
import { getPaymentListByUnit, refundPaymentOrder } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

import ToastMessages from '../../components/ToastMessages'
import PaymentsListItem from './PaymentsListItem'

function PaymentsList() {
  const classes = useStyles()
  const { user, setUser, setAboutCurrentPage, setOpenToast } = useContext(Context)
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState('1')
  const [query, setQuery] = useState('')
  const [checked, setChecked] = useState([])
  const [showPerfilModal, setShowPerfilModal] = useState({ show: false })
  const [paymentList, setPaymentList] = useState([])
  const [unsortedList, setUnsortedList] = useState([])
  const [refundModalData, setRefundModalData] = useState(null)

  const listUpdate = async () => {
    setLoading(true)
    return getPaymentListByUnit(user.partnerUnitId)
  }

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }

    setUser(getLoggedUser())
    setAboutCurrentPage({
      title: 'Validador',
      tabs: [
        { title: 'Validador', pathname: '/uservalidate' },
        { title: 'Pagamentos', pathname: '/paymentslist' },
        { title: 'Cupons', pathname: '/couponslist' }
      ]
    })
    // getData();
  }, [])

  useEffect(() => {
    if (user && user.partnerUnitId) {
      listUpdate().then(res => {
        setPaymentList(res.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)))
        setUnsortedList(res)
        setLoading(false)
      })
    }
  }, [user])

  const errorMessage = ''

  const handleSortByChange = value => {
    setSortBy(value)
    switch (value) {
      case '1':
        console.log('data')
        setPaymentList(unsortedList.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)))
        break

      case '2':
        console.log('nome')
        setPaymentList(unsortedList.sort((a, b) => (a.clientName < b.clientName ? -1 : 1)))
        break

      case '3':
        console.log('valor')
        setPaymentList(
          unsortedList.sort((a, b) => (a.discountedValue < b.discountedValue ? -1 : 1))
        )
        break

      default:
        break
    }
  }

  const handleQueryChange = value => {
    setQuery(value)

    if (value.length > 0) {
      setPaymentList(
        unsortedList.filter(item => item.clientName.toLowerCase().includes(value.toLowerCase()))
      )
    } else {
      setSortBy('1')
      setPaymentList(unsortedList.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)))
    }
  }

  const hidePerfilModal = () => {
    setShowPerfilModal({ show: false })
  }

  const handleCheckUnit = name => {
    if (checked.includes(name)) {
      setChecked(() => checked.filter(item => item !== name))
    } else {
      setChecked([...checked, name])
    }
  }

  const showRefundModal = item => {
    setRefundModalData(item)
    document.activeElement.blur()
  }
  const hideRefundModal = () => setRefundModalData(null)
  const refund = async data => {
    setLoading(true)
    setPaymentList([])
    setUnsortedList([])
    setRefundModalData(null)

    let refunded = await refundPaymentOrder({
      paymentOrderId: data.id,
      refundDescription: data.reason
    })
    setOpenToast({
      open: true,
      message: refunded.message,
      type: refunded.status === 'OK' ? 'success' : 'error'
    })

    let newList = await listUpdate()
    setPaymentList(newList.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)))
    setUnsortedList(newList)

    setLoading(false)
  }

  return (
    <>
      {/* Delete Modal */}
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.row}>
            <div className={classes.filters}>
              <div />
              <div>
                Ordenar por:{' '}
                <select
                  className={classes.sorting}
                  value={sortBy}
                  onChange={e => handleSortByChange(e.target.value)}
                >
                  <option value="1">Data da Compra</option>
                  <option value="2">Nome do Cliente</option>
                  <option value="3">Valor</option>
                </select>
              </div>
            </div>
            <input
              className={classes.search}
              value={query}
              onChange={e => handleQueryChange(e.target.value)}
              placeholder="Buscar..."
            />
          </div>
          <table className={classes.table}>
            <thead>
              <tr>
                <th scope="col">Número da Compra</th>
                <th scope="col">Assinante</th>
                <th scope="col">Valor</th>
                <th scope="col">Data</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {paymentList?.map(item => {
                return (
                  <PaymentsListItem
                    key={item.orderNumber}
                    handleCheckUnit={handleCheckUnit}
                    classes={classes}
                    item={item}
                    checked={checked}
                    showRefundModal={showRefundModal}
                  />
                )
              })}
            </tbody>
          </table>
          {paymentList?.length === 0 && errorMessage === '' && !loading && (
            <div className="alert alert-info text-center m-4">
              Nenhuma compra encontrada para este estabelecimento
            </div>
          )}
          {errorMessage}
          {loading && <LinearProgress style={{ marginTop: 30 }} />}
        </div>
      </div>

      {/* Perfil */}
      <Dialog
        open={!!showPerfilModal.show}
        onClose={hidePerfilModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="sm"
      >
        {/* {console.log(setShowPerfilModal)} */}
        <DialogTitle>
          <strong> Perfil</strong>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText>
            <h4>{showPerfilModal.clientName || 'Nome'}</h4>
          </DialogContentText>
          <DialogContentText>{showPerfilModal.discountedValue || 'Valor Pago'}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={() => hidePerfilModal()}>
            Fechar
          </ButtonGZ>
        </DialogActions>
      </Dialog>

      {/* refund modal */}
      <Dialog
        open={refundModalData}
        onClose={hideRefundModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Estornar pagamento</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <b>Tem certeza de que deseja realizar o estorno? A ação não poderá ser desfeita.</b>
          </DialogContentText>
          <DialogContentText>Nome: {refundModalData?.clientName || '---'}</DialogContentText>
          <DialogContentText>
            Valor pago:{' '}
            {refundModalData?.discountedValue
              ? `R$ ${Number(refundModalData.discountedValue).toFixed(2).replace('.', ',')}`
              : '---'}
          </DialogContentText>
          <DialogContentText>
            <TextField
              variant="outlined"
              label="Motivo"
              shrink
              value={refundModalData?.reason || ''}
              onChange={e =>
                setRefundModalData({
                  ...refundModalData,
                  reason: e.target.value
                })
              }
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={hideRefundModal}>
            Cancelar
          </ButtonGZ>
          <ButtonGZ
            color="primary"
            onClick={() => refund(refundModalData)}
            disabled={!refundModalData?.reason?.trim()}
          >
            Estornar
          </ButtonGZ>
        </DialogActions>
      </Dialog>

      <ToastMessages />
    </>
  )
}

export default PaymentsList
